/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import CustomModal from "components/CustomModal/CustomModal";
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function Footer() {
  const [privacyModal, setPrivacyModal] = React.useState(false);

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md="2"></Col>
          <Col md="2"></Col>
          <Col md="2">
            <Nav>
              <NavItem>
                <NavLink to="/" tag={Link}>
                  <b>C-HUB</b> &copy; {new Date().getFullYear()}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="#"
                  tag={Link}
                  onClick={() => setPrivacyModal(true)}
                >
                  Privacy Policy
                </NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col sm="1" xs="6" className="mt-4 mt-sm-4">
            <img
              id="angolan-embassy"
              alt="..."
              className="img-fluid rounded shadow"
              src={require("assets/img/angolan_embassy.png")}
              style={{ width: "40px" }}
            />
            <UncontrolledTooltip placement="bottom" target="angolan-embassy">
              Angolan Embassy
            </UncontrolledTooltip>
          </Col>

          <Col sm="1" xs="6" className="mt-4 mt-sm-4">
            <img
              id="bmw-it-hub"
              alt="..."
              className="img-fluid rounded shadow"
              src={require("assets/img/BMW.png")}
              style={{ width: "40px" }}
            />
            <UncontrolledTooltip placement="bottom" target="bmw-it-hub">
              BMW IT HUB
            </UncontrolledTooltip>
          </Col>
          <Col sm="1" xs="6" className="mt-4 mt-sm-4">
            <img
              id="poop-troop"
              alt="..."
              className="img-fluid rounded shadow"
              src={require("assets/img/poop_troop_logo.png")}
              style={{ width: "40px" }}
            />
            <UncontrolledTooltip placement="bottom" target="poop-troop">
              Poop Troop
            </UncontrolledTooltip>
          </Col>
          <Col sm="1" xs="6" className="mt-4 mt-sm-4">
            <img
              id="blue-gecko"
              alt="..."
              className="img-fluid rounded shadow"
              src={require("assets/img/blue_gecko_logo.jpeg")}
              style={{ width: "40px" }}
            />
            <UncontrolledTooltip placement="bottom" target="blue-gecko">
              Blue Gecko
            </UncontrolledTooltip>
          </Col>

          <CustomModal
            title={"Privacy"}
            formModal={privacyModal}
            setFormModal={setPrivacyModal}
          >
            <p style={{ textAlign: "justify" }}>
              At Cardoso Hub (from here onwards to be referred to as “C-HUB” we
              collect and manage user data according to the following Privacy
              Policy. Below you will find information concerning visits to and
              the use of C-HUB website. C-HUB is sensitive to privacy issues on
              the internet and recognizes the importance of safeguarding all
              information we receive from you. This Privacy Policy applies to
              data provided by you and collected by C-HUB website. We will use
              the provided information to process requests, enquiries and
              provide a more personalized browsing experience. C-HUB ensure that
              all personal information is treated in accordance with the
              applicable data privacy legislation of South Africa.
            </p>
          </CustomModal>
        </Row>
      </Container>
    </footer>
  );
}
